import {arrowsInwardSvg as Icon__small__arrowsInwardSvg} from '../Icon__small/Icon__small--arrowsInward.js';
import {arrowsInwardSvg as Icon__xsmall__arrowsInwardSvg} from '../Icon__xsmall/Icon__xsmall--arrowsInward.js';

export var arrowsInward = {
  name: 'arrowsInward',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowsInwardSvg,
  alt: {
    Icon__small: Icon__small__arrowsInwardSvg,
    Icon__xsmall: Icon__xsmall__arrowsInwardSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
